module.exports = __webpack_public_path__ + "img/disease.80c01420.svg";